import React from "react";

const Web3Face = () => {
  return (
    <div style={{ color: "white", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ color: "#00ffff", borderBottom: "2px solid #00ffff", paddingBottom: "10px" }}>
        🌐 Web3 & Blockchain
      </h2>
      
      <p style={{ marginTop: "15px", opacity: 0.9 }}>
        Arquitecto de soluciones descentralizadas. Mi enfoque es crear protocolos seguros, escalables y con una economía de tokens (Tokenomics) sostenible.
      </p>

      <div style={{ marginTop: "20px" }}>
        <h3 style={{ color: "#00ffff", fontSize: "16px" }}>Core Skills:</h3>
        <ul style={{ fontSize: "14px", opacity: 0.8 }}>
          <li>Arquitectura de Smart Contracts (DeFi & NFT).</li>
          <li>Optimización de Gas en redes EVM.</li>
          <li>Integración de Web3 Providers (Ethers, Viem).</li>
        </ul>
      </div>

      {/* SECCIÓN DE PRODUCTO RELACIONADO */}
      <div style={{ 
        marginTop: "25px", 
        padding: "15px", 
        background: "rgba(0, 255, 255, 0.1)", 
        borderRadius: "12px", 
        border: "1px dashed #00ffff" 
      }}>
        <h4 style={{ margin: "0 0 10px 0", color: "#00ffff", fontSize: "14px" }}>🚀 Producto de FrancoLab:</h4>
        <p style={{ fontSize: "13px", margin: "0 0 10px 0" }}>
          <strong>FrancoSwap:</strong> Un DEX multichain con agregador de liquidez optimizado.
        </p>
        <a 
          href="https://github.com/tu-usuario/francoswap" // Cambia por tu link real
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: "#00ffff", fontSize: "13px", fontWeight: "bold", textDecoration: "none" }}
        >
          Ver Demo en Vivo →
        </a>
      </div>
    </div>
  );
};

export default Web3Face;